<template>
  <v-content class="custom-background">
    <router-view />
    <v-spacer />
    <dashboard-core-footer />
  </v-content>
</template>

<script>
export default {
  name: "DashboardCoreView",

  components: {
    DashboardCoreFooter: () => import("./Footer")
  }
};
</script>
<style scoped>
/* พื้นหลัง (ขาว + ฟ้าอ่อน + ลาย Network) กำหนดรวมที่ src/sass/hrvec-theme.scss */
.custom-background {
  background-color: var(--hv-surface);
}
</style>